import {
  isLarkBrowser,
  openWindow,
  isDingtalkBrowser,
  isWeComeBrowser,
  replaceSecondLevelDomain,
} from "@/utils";
import { AppInfo } from "./types";
import { Protocol } from "@/config";
import Axios from "axios";
import qs from "query-string";

export const openApp = (v: AppInfo) => {
  let url: string;
  let query: Record<string, any> = {};
  // 集成应用的登录
  if (v.isIntegrate) {
    url = `/apps/${v.id}`;
  } else if (v.initLoginUrl) {
    url = v.initLoginUrl;
  } else if (v.protocol === Protocol.SAML) {
    url =
      `${window.location.protocol}//` +
      `${replaceSecondLevelDomain(window.location.host, v.identifier)}` +
      `/api/v2/saml-idp/${v.id}`;
  } else {
    // 跳转到此应用的域名下
    url =
      `${window.location.protocol}//` +
      `${replaceSecondLevelDomain(window.location.host, v.identifier)}` +
      `/login`;
    query.app_id = v.id;
  }

  const appUrl = `${url}?${qs.stringify(query)}`;

  if (isLarkBrowser() || isDingtalkBrowser() || isWeComeBrowser()) {
    Axios.post("/cas/create-temporary-token")
      .then(({ data: token }) => {
        const createTokenQuery = {
          token,
          redirect_uri: appUrl,
        };
        openWindow(
          `/cas/login-by-temporary-token?${qs.stringify(createTokenQuery)}`
        );
      })
      .catch(() => openWindow(appUrl));
  } else {
    openWindow(appUrl);
  }
};
